(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!/\/collections\/lot-archive(?:\/|$)/.test(location.pathname || '')) return;

    var API_BASE = (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url') || '').replace(
      /\/+$/,
      ''
    );
    if (!API_BASE) return;

    var headers = window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept: 'application/json' };

    function rowAttrs(payload) {
      if (!payload) return null;
      var data = payload.data && !Array.isArray(payload.data) ? payload.data : payload;
      if (!data) return null;
      return data.attributes || data;
    }

    function hasWinner(attrs) {
      if (!attrs) return false;
      var winnerRaw = attrs.winner_id != null ? attrs.winner_id : attrs.winner_customer_id;
      return (
        winnerRaw != null &&
        String(winnerRaw).trim() !== '' &&
        String(winnerRaw).toLowerCase() !== 'null'
      );
    }

    /**
     * A lot with a winner shows what it hammered for, straight from the auction.
     *
     * A lot with no winner was rolled into Buy Now, and that conversion writes the
     * boosted price to the Shopify variant alone — the auction keeps its pre-roll
     * starting price. Reading the auction there showed the old, lower number: its
     * auction_ended_price is 0 without a winning bid, and current_price falls back
     * to the starting price when no bid was ever placed. So the store price wins
     * for a winner-less lot, matching last-bids.js on the product page and
     * past-auctions.js on the past-catalogue cards.
     *
     * The auction chain stays behind it as a fallback: the hidden product map is
     * capped at 1000 products, so a lot beyond that carries no store price.
     */
    function resolveHammerPrice(attrs, storeDollars) {
      if (!attrs) return storeDollars;
      var winner = hasWinner(attrs);
      var store = Number(storeDollars);
      var price = null;
      if (winner) {
        if (attrs.hammer_price != null) price = Number(attrs.hammer_price);
        else if (attrs.auction_ended_price != null) price = Number(attrs.auction_ended_price);
        else if (attrs.current_price != null) price = Number(attrs.current_price);
      } else {
        if (storeDollars != null && isFinite(store) && store > 0) return store;
        // auction_ended_price is 0 for a winner-less lot, so only take it when real.
        if (attrs.auction_ended_price != null && Number(attrs.auction_ended_price) > 0) {
          price = Number(attrs.auction_ended_price);
        } else if (attrs.current_price != null) {
          price = Number(attrs.current_price);
        }
      }
      if (price != null && isFinite(price) && price > 0) return price;
      if (window.staAuctionDisplayPrice) {
        var fromAttrs = window.staAuctionDisplayPrice(attrs, storeDollars);
        if (fromAttrs != null && fromAttrs > 0) return fromAttrs;
      }
      return storeDollars;
    }

    function setMoneyPrice(el, dollars) {
      if (!el || dollars == null || !isFinite(Number(dollars))) return;
      if (window.staSetMoneyEl) window.staSetMoneyEl(el, dollars);
      else if (window.staFormatMoney) el.innerHTML = window.staFormatMoney(dollars);
    }

    function fetchAuctionForCard(productId) {
      var mapId = window.staResolveAuctionIdFromMap ? window.staResolveAuctionIdFromMap(productId) : '';
      if (mapId) {
        var customerId = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';
        var path = window.staAuctionShowPath
          ? window.staAuctionShowPath(mapId, customerId)
          : '/api/auctions/' + encodeURIComponent(mapId);
        return fetch(API_BASE + path, { headers: headers, mode: 'cors' })
          .then(function (r) {
            if (!r.ok) return null;
            return r.json();
          })
          .then(rowAttrs);
      }
      if (!window.staFetchAuctionsByProductIds) return Promise.resolve(null);
      return window.staFetchAuctionsByProductIds([productId], { perPage: 1 })
        .then(function (payload) {
          var rows = window.staPickAuctionArray
            ? window.staPickAuctionArray(payload)
            : (payload && payload.data) || [];
          if (!rows.length) return null;
          var row = rows[0];
          return row.attributes || row;
        })
        .catch(function () {
          return null;
        });
    }

    function paintCard(card, attrs) {
      if (!attrs) return;

      var skuEl = card.querySelector('[data-sta-archive-sku]');
      var sku = attrs.product_sku || '';
      if (skuEl && sku) skuEl.textContent = 'SKU: ' + sku;

      var productId = card.getAttribute('data-product-id') || '';
      var storeDollars = productId && window.staStorePriceDollars ? window.staStorePriceDollars(productId) : null;
      var winner = hasWinner(attrs);
      var price = resolveHammerPrice(attrs, storeDollars);
      if (price == null || !isFinite(price) || price <= 0) return;

      var priceRow = card.querySelector('[data-sta-archive-price-row]');
      var priceWrap = card.querySelector('[data-sta-archive-price-wrap]');
      var priceLabel = card.querySelector('[data-sta-archive-price-label]');
      var priceEl = card.querySelector('[data-sta-archive-price]');

      if (priceRow) priceRow.hidden = false;
      // Archive lots are always sold: Buy Now lots (no winner) show what they sold for.
      if (priceLabel) priceLabel.textContent = winner ? 'Hammer price:' : 'Sold for:';
      if (priceWrap) {
        priceWrap.classList.toggle('sta-product-price--hammer', winner);
      }
      if (priceEl) {
        priceEl.classList.toggle('sta-product-price__price--hammer', winner);
        setMoneyPrice(priceEl, price);
      }
    }

    var cards = document.querySelectorAll('[data-sta-archive-lot][data-product-id]');
    cards.forEach(function (card) {
      var productId = (card.getAttribute('data-product-id') || '').trim();
      if (!productId) return;
      fetchAuctionForCard(productId).then(function (attrs) {
        paintCard(card, attrs);
      });
    });
  });
})();
